export const authentication = (type: string) => {
  const { bizType, businessConfigUuid } = alo7Nav.getCurrentSearchObject();

  if (bizType === 'independent') {
    return alo7Account.permissions[
      `${type}Catalogue_${businessConfigUuid}`
    ];
  } else {
    return alo7Account.permissions[`${type}Course`];
  }
};
